module.exports = __webpack_public_path__ + "static/media/Robert_Allen_Resume.429e982b.pdf";